import { ThemeProvider } from "styled-components";
import Main from "./pages/Main";
import { Constant } from "./helper/constant";
import GlobalStyles from "./components/styles/Global";

const App = () => (
  <ThemeProvider theme={Constant.theme}>
    <GlobalStyles />
    <Main />
  </ThemeProvider>
);

export default App;
